export const chartColors = ['#f87171', '#22d3ee', '#34d399', '#fcd34d', '#a78bfa', '#fb923c', '#f472b6', '#d1d5db']
